import { actions } from '../constants/question';
import * as actionTypes from '../../models/action/question';
import { IAction } from '../../models/action/core';

import { Log } from 'ng2-logger';
import { IFilter, IQuestionData, IQuestions  } from '../../models/components/questions';
import { IPagedQueryS } from '../../models/components/paginate';
import { RefreshUploadMultiQuestionRequestParam, IRefreshUploadMultiQuestionViewModel } from '../../models/action/question';
import { QuestionType } from '../../models/enums/QuestionType';

const _logger = Log.create('QuestionBank');

export function SetQuestionList(results: Array<IQuestionData>, filters: IPagedQueryS, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.ISetQuestionList {
    return {
        results,
        filters,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_QUESTION_LIST
    };
}

export function GetQuestionList(filters: IFilter, paging: IPagedQueryS, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IQuestionList {
    return {
        filters,
        paging,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_QUESTION_LIST
    };
}

export function AddQuestion(values: IQuestionData, callback?: (value: any) => void, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IAddQuestions {
    return {
        values,
        callback,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_QUESTION
    };
}

export function DeleteQuestion(
    filters: IFilter, 
    isAll: boolean, 
    selectedQuestionIds: Array<string>, 
    callback: () => void, 
    disAllowedQuestionIds?: Array<string>,
    spinnerId?: string, 
    spinnerType?: 'get' | 'set'): actionTypes.IDeletedQuestion {
    return {
        filters,
        isAll,
        selectedQuestionIds,
        callback,
        disAllowedQuestionIds,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.DELETE_QUESTION
    };
}

export function DownloadQuestion(
    filters: IFilter, 
    isAll: boolean, 
    selectedQuestionIds: Array<string>, 
    callback: () => void, 
    disAllowedQuestionIds?: Array<string>,
    spinnerId?: string, 
    spinnerType?: 'get' | 'set'): actionTypes.IDeletedQuestion {
    return {
        filters,
        isAll,
        selectedQuestionIds,
        callback,
        disAllowedQuestionIds,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.DOWNLOAD_QUESTION
    };
}

export function GetQuestion( take: number, skip: number, questionIds?: Array<string>, spinnerId?: string, spinnerType?: 'get' | 'set',callback?: () => void,): actionTypes.IGetQuestion {
    return {
        questionIds,
        take,
        skip,
        callback,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_QUESTION
    };
}
export function SetQuestion(results: Array<IQuestionData>,spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.ISetQuestion {
    return {
        results,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_QUESTION
    };
}

export function setQuestionDataDefault(spinnerId?: string, spinnerType?: 'get' | 'set'): any {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_QUESTION_DEFAULT_DATA
    };
}

export function editQuestionGetAction(
    questionId: string,
    callback?: (value: any) => void,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.IGetQuestionById {
    return {
        questionId,
        callback,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_QUESTION_DATA
    };
}

export function editQuestionSetAction(
    values: IQuestionData,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.IAddQuestions {
    return {
        values,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_QUESTION_DATA
    };
}

export function getQuestionDifficulties(
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.IGetQuestionDifficulties {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_QUESTION_DIFFICULTIES
    };
}

export function setQuestionDifficulties(
    values: Array<{ label: string; value: string }>,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.ISetQuestionDifficulties {
    return {
        values,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_QUESTION_DIFFICULTIES
    };
}

export function redirectToAlmsQuestionBank(spinnerId?: string, spinnerType?: 'get' | 'set', parameters?: any): actionTypes.IRedirectToAlmsQuestionBankAction {
    return {
        spinnerId,
        spinnerType,
        parameters,
        timestamp: Date.now(),
        type: actions.REDIRECT_TO_ALMS_QUESTION_BANK,
    };
}

export function QuestionBankDownloadTemplateExcel(questionType: QuestionType, spinnerId?: string, spinnerType?: 'get' | 'set',): actionTypes.IQuestionBankDownloadTemplateExcel {
    return {
        questionType,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.QUESTION_BANK_DOWNLOAD_TEMPLATE_EXCEL,
    };
}

export function GetRefreshUploadMultiQuestion(parameters: RefreshUploadMultiQuestionRequestParam, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: any): actionTypes.IGetRefreshUploadMultiQuestion {
    return {
        parameters,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        callback,
        type: actions.GET_REFRESH_UPLOAD_MULTI_QUESTION,
    };
}

export function SetRefreshUploadMultiQuestion(model: IRefreshUploadMultiQuestionViewModel, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: any): actionTypes.ISetRefreshUploadMultiQuestion {
    return {
        model,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        callback,
        type: actions.SET_REFRESH_UPLOAD_MULTI_QUESTION,
    };
}

export function SetFileMultiUploadId(fileUploadId: string, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: any): actionTypes.ISetMultiFileUploadId {
    return {
        fileUploadId,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        callback,
        type: actions.SET_FILE_MULTI_UPLOAD_ID,
    };
}